<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-3 pt-5 pt-md-8">
            
    </base-header>
    <card shadow type="secondary">
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">Organization</h3>
                  </div>
                </div>
              </div>
              <template>
              <form>
                <h6 class="heading-small text-muted mb-4">Organization information</h6>
                  <div class="pl-lg-4">
                    <div class="row">
                      <div class="col-lg-6">
                        <base-input alternative=""
                          label="Tên Công Ty"
                          placeholder="Tên Công Ty"
                          input-classes="form-control-alternative"
                          v-model="org.name"
                        />
                      </div>
                      <div class="col-lg-6">
                        <base-input alternative=""
                          label="Tên Viết Tắt"
                          placeholder="slug"
                          input-classes="form-control-alternative"
                          v-model="org.slug"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4">
                        <base-input alternative=""
                          label="Giấy Phép KD"
                          placeholder="Giấy Phép KD"
                          input-classes="form-control-alternative"
                          v-model="org.cardid"
                        />
                      </div>
                      <div class="col-lg-4">
                        <base-input label="Phân Loại">
                        <select class="form-control" v-model.number="org.type">
                          <option value=1>Khách Hàng</option>
                          <option value=2>Đối Tác</option>
                          <option value=3>Cả Hai</option>
                        </select>
                        </base-input>
                      </div>
                      <div class="col-ld-4 pt-5 align-items-end">
                        <base-checkbox class="mb-4" v-model="org.isactive">Active</base-checkbox> 
                      </div>
                    </div>
                  </div>
                    <hr class="my-4" />
                      <!-- Address -->
                      <h6 class="heading-small text-muted mb-4">Contact information</h6>
                      <div class="pl-lg-4">
                        <div class="row">
                          <div class="col-md-12">
                            <base-input alternative=""
                              label="Địa Chỉ"
                              placeholder="Địa Chỉ Công Ty"
                              input-classes="form-control-alternative"
                              v-model="org.address"
                            />
                          </div>
                        </div>
                       <div class="row">
                         <div class="col-lg-6">
                           <base-input alternative=""
                             label="Email"
                             placeholder="Email"
                             input-classes="form-control-alternative"
                             v-model="org.email"
                           />
                         </div>
                         <div class="col-lg-6">
                           <base-input alternative=""
                             label="Mobile"
                             placeholder="Mobile"
                             input-classes="form-control-alternative"
                             v-model="org.mobile"
                           />
                         </div>
                        </div>
                      </div>
                      <hr class="my-4" />
                      <!-- Address -->
                      <h6 class="heading-small text-muted mb-4">Attach</h6>
                      <div class="pl-lg-4">
                        <div class="row">
                          <div class="col-3">
                            <vue-dropzone ref="myVueDropzone" id="dropzone" v-on:vdropzone-sending="sendingEvent" :options="dropzoneOptions"></vue-dropzone>
                          </div>
                          <div class="col-9">
                            <ol>                        
                              <li v-for="(file,index) in org.files" :key="index">
                                  <div class="row">
                                  <div class="col">
                                  <p>
                                    {{file.filename}}  
                                  </p>
                                  </div>
                                  <div class="col">
                                    <base-button type="primary" class="btn-sm" @click="getfile(file)">Download</base-button>
                                  </div>
                                  </div>
                              </li>
                            </ol>
                          </div>
                        </div>
                      </div>
                      <hr class="my-4" />
                       <!-- Description -->
                       <h6 class="heading-small text-muted mb-4">Description</h6>
                       <div class="pl-lg-4">
                         <div class="form-group">
                            <base-input alternative=""
                              label="Thông tin">
                              <textarea rows="4" class="form-control form-control-alternative" placeholder="Thêm thông tin ..." v-bind="org.description"></textarea>
                            </base-input>
                          </div>
                        </div>
                      <div class="col text-right">
                        <base-button type="primary" class="my-4" @click="updateOrg">Cập Nhật</base-button> 
                      </div>
                      </form>
              </template>
    </card>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
        org: {
          _id: '',
          name: '',
          slug: '',
          type: 1,
          cardid: '',
          mobile: '',
          address: '',
          description: '',
          isactive: true
        },
        err: '',
        dropzoneOptions: {
          url: 'http://222.255.100.41:3000/organizations/upload',
          thumbnailWidth: 150,
          maxFilesize: 15,
          headers: { "Authorization": "jwt "+ this.$store.state.token }
      }
    }
  },
  mounted() {
    this.detailOrg()
  },
  methods: {
    detailOrg() {
      this.$http.get('/organizations/detail/', {params:{"id": this.$route.params.orgid}}).then((res) => {
        this.org = res.data
    })
    },
    updateOrg() {
      this.$http.post('/organizations/edit', this.org ).then(()=> {
        this.$router.push('/organizations')
      }).catch((err)=> {
        this.$notify({type: 'warning', message: err});
        this.$router.push(this.org._id)
      })
    },
    sendingEvent (file, xhr, formData) {
        formData.append('orgName', this.org.name)
        formData.append('orgId', this.org._id)
      },
      getfile(file) {
        this.$http.get('/uploads/tenants/'+file.filename, {responseType: 'arraybuffer'},{headers: {'Accept': file.minetype }}).then((response) => {
                     var fileURL = window.URL.createObjectURL(new Blob([response.data],{type: file.minetype} ));
                     var fileLink = document.createElement('a');
                     fileLink.style.display = "none";
                     fileLink.href = fileURL; 
                     fileLink.setAttribute('download', file.filename);
                     document.body.appendChild(fileLink);
   
                     fileLink.click();
                });
      }
  },
  computed:{

  }
}
</script>
<style>

</style>